import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { useAuth } from "@/shared/stores/auth";
import { usePermission } from "@/shared/composables/usePermission";
import { useNotify } from "@/shared/composables/useNotify";

export function authGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void {
  const authStore = useAuth();

  const requiresAuth = to.meta.requiresAuth;
  const requiredPermissions: string[] = to.meta.permissions as string[] | undefined;

  if (requiresAuth) {
    if (!authStore.accessToken) {
      return next({ name: "Login", query: { redirect: to.fullPath } });
    }

    if (requiredPermissions && requiredPermissions.length > 0) {
      const hasPermission = usePermission(...requiredPermissions);

      if (hasPermission) {
        return next();
      } else {
        useNotify({
          message: "Acesso negado: o usuário não possui as permissões necessárias.",
          type: "warning",
        });
        return next(false);
      }
    }

    return next();
  }

  return next();
}
